module.exports = __webpack_public_path__ + "static/media/7.42d86b90.jpeg";